import { AuthLayout } from "../layouts/AuthLayout";
import urlImage from "../../assets/logo.png";
import { Button, TextInput } from "@tremor/react";
import { Link } from "react-router-dom";
export const RecoveryPasswordPage = () => {
  return (
    <AuthLayout>
      <img className="w-50 mx-auto rounded-md" src={urlImage}></img>
      <p className="text-3xl my-3 text-center">Recuperar Contraseña</p>
      <TextInput
        type="text"
        className="rounded mb-3"
        placeholder="email@email.com"
      />
      <Button className="bg-button-main rounded w-min mx-auto">
        <Link to="/"> Login</Link>
      </Button>
    </AuthLayout>
  );
};
